import { render, staticRenderFns } from "./ServiceVendorDropdownField.vue?vue&type=template&id=ac7e91bc"
import script from "./ServiceVendorDropdownField.vue?vue&type=script&lang=ts"
export * from "./ServiceVendorDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac7e91bc')) {
      api.createRecord('ac7e91bc', component.options)
    } else {
      api.reload('ac7e91bc', component.options)
    }
    module.hot.accept("./ServiceVendorDropdownField.vue?vue&type=template&id=ac7e91bc", function () {
      api.rerender('ac7e91bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/ServiceVendorDropdownField.vue"
export default component.exports